var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConferenceUserRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 20,
    width: 8,
    height: 2.5,
    rx: 0.5,
    fill: "#2760A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0999 22.0005C23.1284 22.0005 24.1338 21.7072 24.989 21.1578C25.8441 20.6083 26.5107 19.8274 26.9043 18.9137C27.2978 18.0001 27.4008 16.9947 27.2002 16.0247C26.9995 15.0548 26.5043 14.1638 25.777 13.4645C25.0497 12.7652 24.1231 12.289 23.1144 12.0961C22.1057 11.9031 21.0601 12.0022 20.1099 12.3806C19.1596 12.7591 18.3475 13.4 17.7761 14.2223C17.2047 15.0446 16.8997 16.0113 16.8997 17.0003C16.8997 18.3262 17.4475 19.5987 18.4225 20.5362C19.3976 21.4738 20.721 22.0005 22.0999 22.0005ZM25.7398 23.2501H25.061C24.1325 23.6619 23.122 23.8752 22.0994 23.8752C21.0768 23.8752 20.0664 23.6619 19.1378 23.2501H18.4599C17.0117 23.2503 15.623 23.8037 14.5991 24.7884C13.5752 25.7731 13 27.1085 13 28.501V30.1251C13.0003 30.6223 13.2058 31.099 13.5714 31.4506C13.937 31.8021 14.4328 31.9997 14.9498 32H29.2499C29.767 31.9997 30.2627 31.8021 30.6283 31.4506C30.994 31.099 31.1995 30.6223 31.1997 30.1251V28.501C31.1995 27.1087 30.6242 25.7735 29.6003 24.789C28.5764 23.8045 27.1878 23.2503 25.7398 23.2501Z",
    fill: "#2760A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 45.25,
    height: 45.25,
    rx: 7.625,
    stroke: "#2760A3",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConferenceUserRemove);
export default __webpack_public_path__ + "static/media/conference-user-remove.58819fd0a9629eccb019d64e7fa1130e.svg";
export { ForwardRef as ReactComponent };